import { canGoBack } from "src/utils/navigation.utils";

import { BackButton } from "./BackButton";

type BackButtonWithConditionProps = {
  className?: string;
};

export const BackButtonWithCondition: React.FC<BackButtonWithConditionProps> = ({ className }) => {
  return canGoBack() ? <BackButton className={className} /> : null;
};
